import { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface BrowserFrameProps {
  url?: string;
  children: ReactNode;
  className?: string;
  innerClassName?: string;
}

export function BrowserFrame({
  url = "app.funnlr.co/dashboard",
  children,
  className,
  innerClassName,
}: BrowserFrameProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-xl border border-slate-200/80 bg-white shadow-2xl shadow-slate-300/30 ring-1 ring-slate-900/[0.03]",
        className,
      )}
    >
      <div className="flex h-9 items-center gap-2 border-b border-slate-100 bg-slate-50/80 px-3.5">
        <div className="flex gap-1.5">
          <div className="h-2.5 w-2.5 rounded-full bg-[#FF5F57]" />
          <div className="h-2.5 w-2.5 rounded-full bg-[#FEBC2E]" />
          <div className="h-2.5 w-2.5 rounded-full bg-[#28C840]" />
        </div>
        <div className="ml-2 flex h-5 flex-1 items-center justify-center rounded bg-white px-3 ring-1 ring-slate-200/60">
          <span className="truncate text-[10px] font-medium tracking-tight text-slate-400">
            {url}
          </span>
        </div>
      </div>

      <div className={cn("relative", innerClassName)}>{children}</div>
    </div>
  );
}
